var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownPrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3112 1.6666L7.33933 7.38848C7.13933 7.55723 6.95183 7.62598 6.79246 7.62598C6.63308 7.62598 6.4184 7.55664 6.27402 7.41698L0.274021 1.6666C-0.0258536 1.38223 -0.0356035 0.879102 0.251522 0.607227C0.536678 0.306445 1.0134 0.296665 1.31121 0.584768L6.79246 5.83848L12.2737 0.588479C12.5706 0.300385 13.0481 0.310167 13.3334 0.610939C13.6206 0.879105 13.6112 1.38223 13.3112 1.6666Z",
    fill: "#707A83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownPrice);
export default __webpack_public_path__ + "static/media/arrow-down-price.575341d4dc64158cd90d675f7f4e47c0.svg";
export { ForwardRef as ReactComponent };